/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DesktopLoginRouteImport } from './routes/desktop-login'
import { Route as LoginRouteImport } from './routes/login'
import { Route as QuickCaptureRouteImport } from './routes/quick-capture'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAgentsRouteImport } from './routes/_app/agents'
import { Route as AppArchivRouteImport } from './routes/_app/archiv'
import { Route as AppBereicheRouteImport } from './routes/_app/bereiche'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppEinstellungenRouteImport } from './routes/_app/einstellungen'
import { Route as AppEntscheidungenRouteImport } from './routes/_app/entscheidungen'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppParaRouteImport } from './routes/_app/para'
import { Route as AppProjekteRouteImport } from './routes/_app/projekte'
import { Route as AppRessourcenRouteImport } from './routes/_app/ressourcen'
import { Route as AppSucheRouteImport } from './routes/_app/suche'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppZusagenRouteImport } from './routes/_app/zusagen'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as OauthLoginRouteImport } from './routes/oauth.login'
import { Route as AppCContainerIdRouteImport } from './routes/_app/c.$containerId'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings.index'
import { Route as AppMeetingsMeetingIdRouteImport } from './routes/_app/meetings.$meetingId'
import { Route as AppNNoteIdRouteImport } from './routes/_app/n.$noteId'
import { Route as AppPersonenIndexRouteImport } from './routes/_app/personen.index'
import { Route as AppPersonenPersonIdRouteImport } from './routes/_app/personen.$personId'
import { Route as AppVorbereitungPrepIdRouteImport } from './routes/_app/vorbereitung.$prepId'
import { Route as AppMeetingsLiveMeetingIdRouteImport } from './routes/_app/meetings.live.$meetingId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopLoginRoute = DesktopLoginRouteImport.update({
  id: '/desktop-login',
  path: '/desktop-login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickCaptureRoute = QuickCaptureRouteImport.update({
  id: '/quick-capture',
  path: '/quick-capture',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsRoute = AppAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppRoute,
} as any)
const AppArchivRoute = AppArchivRouteImport.update({
  id: '/archiv',
  path: '/archiv',
  getParentRoute: () => AppRoute,
} as any)
const AppBereicheRoute = AppBereicheRouteImport.update({
  id: '/bereiche',
  path: '/bereiche',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppEinstellungenRoute = AppEinstellungenRouteImport.update({
  id: '/einstellungen',
  path: '/einstellungen',
  getParentRoute: () => AppRoute,
} as any)
const AppEntscheidungenRoute = AppEntscheidungenRouteImport.update({
  id: '/entscheidungen',
  path: '/entscheidungen',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppParaRoute = AppParaRouteImport.update({
  id: '/para',
  path: '/para',
  getParentRoute: () => AppRoute,
} as any)
const AppProjekteRoute = AppProjekteRouteImport.update({
  id: '/projekte',
  path: '/projekte',
  getParentRoute: () => AppRoute,
} as any)
const AppRessourcenRoute = AppRessourcenRouteImport.update({
  id: '/ressourcen',
  path: '/ressourcen',
  getParentRoute: () => AppRoute,
} as any)
const AppSucheRoute = AppSucheRouteImport.update({
  id: '/suche',
  path: '/suche',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppZusagenRoute = AppZusagenRouteImport.update({
  id: '/zusagen',
  path: '/zusagen',
  getParentRoute: () => AppRoute,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthLoginRoute = OauthLoginRouteImport.update({
  id: '/oauth/login',
  path: '/oauth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCContainerIdRoute = AppCContainerIdRouteImport.update({
  id: '/c/$containerId',
  path: '/c/$containerId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsMeetingIdRoute = AppMeetingsMeetingIdRouteImport.update({
  id: '/meetings/$meetingId',
  path: '/meetings/$meetingId',
  getParentRoute: () => AppRoute,
} as any)
const AppNNoteIdRoute = AppNNoteIdRouteImport.update({
  id: '/n/$noteId',
  path: '/n/$noteId',
  getParentRoute: () => AppRoute,
} as any)
const AppPersonenIndexRoute = AppPersonenIndexRouteImport.update({
  id: '/personen/',
  path: '/personen/',
  getParentRoute: () => AppRoute,
} as any)
const AppPersonenPersonIdRoute = AppPersonenPersonIdRouteImport.update({
  id: '/personen/$personId',
  path: '/personen/$personId',
  getParentRoute: () => AppRoute,
} as any)
const AppVorbereitungPrepIdRoute = AppVorbereitungPrepIdRouteImport.update({
  id: '/vorbereitung/$prepId',
  path: '/vorbereitung/$prepId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsLiveMeetingIdRoute =
  AppMeetingsLiveMeetingIdRouteImport.update({
    id: '/meetings/live/$meetingId',
    path: '/meetings/live/$meetingId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/quick-capture': typeof QuickCaptureRoute
  '/agents': typeof AppAgentsRoute
  '/archiv': typeof AppArchivRoute
  '/bereiche': typeof AppBereicheRoute
  '/chat': typeof AppChatRoute
  '/einstellungen': typeof AppEinstellungenRoute
  '/entscheidungen': typeof AppEntscheidungenRoute
  '/inbox': typeof AppInboxRoute
  '/para': typeof AppParaRoute
  '/projekte': typeof AppProjekteRoute
  '/ressourcen': typeof AppRessourcenRoute
  '/suche': typeof AppSucheRoute
  '/tasks': typeof AppTasksRoute
  '/zusagen': typeof AppZusagenRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/login': typeof OauthLoginRoute
  '/c/$containerId': typeof AppCContainerIdRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/n/$noteId': typeof AppNNoteIdRoute
  '/personen/$personId': typeof AppPersonenPersonIdRoute
  '/vorbereitung/$prepId': typeof AppVorbereitungPrepIdRoute
  '/meetings/': typeof AppMeetingsIndexRoute
  '/personen/': typeof AppPersonenIndexRoute
  '/meetings/live/$meetingId': typeof AppMeetingsLiveMeetingIdRoute
}
export interface FileRoutesByTo {
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/quick-capture': typeof QuickCaptureRoute
  '/agents': typeof AppAgentsRoute
  '/archiv': typeof AppArchivRoute
  '/bereiche': typeof AppBereicheRoute
  '/chat': typeof AppChatRoute
  '/einstellungen': typeof AppEinstellungenRoute
  '/entscheidungen': typeof AppEntscheidungenRoute
  '/inbox': typeof AppInboxRoute
  '/para': typeof AppParaRoute
  '/projekte': typeof AppProjekteRoute
  '/ressourcen': typeof AppRessourcenRoute
  '/suche': typeof AppSucheRoute
  '/tasks': typeof AppTasksRoute
  '/zusagen': typeof AppZusagenRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/login': typeof OauthLoginRoute
  '/': typeof AppIndexRoute
  '/c/$containerId': typeof AppCContainerIdRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/n/$noteId': typeof AppNNoteIdRoute
  '/personen/$personId': typeof AppPersonenPersonIdRoute
  '/vorbereitung/$prepId': typeof AppVorbereitungPrepIdRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/personen': typeof AppPersonenIndexRoute
  '/meetings/live/$meetingId': typeof AppMeetingsLiveMeetingIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/desktop-login': typeof DesktopLoginRoute
  '/login': typeof LoginRoute
  '/quick-capture': typeof QuickCaptureRoute
  '/_app/agents': typeof AppAgentsRoute
  '/_app/archiv': typeof AppArchivRoute
  '/_app/bereiche': typeof AppBereicheRoute
  '/_app/chat': typeof AppChatRoute
  '/_app/einstellungen': typeof AppEinstellungenRoute
  '/_app/entscheidungen': typeof AppEntscheidungenRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/para': typeof AppParaRoute
  '/_app/projekte': typeof AppProjekteRoute
  '/_app/ressourcen': typeof AppRessourcenRoute
  '/_app/suche': typeof AppSucheRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/zusagen': typeof AppZusagenRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/oauth/login': typeof OauthLoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/c/$containerId': typeof AppCContainerIdRoute
  '/_app/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/_app/n/$noteId': typeof AppNNoteIdRoute
  '/_app/personen/$personId': typeof AppPersonenPersonIdRoute
  '/_app/vorbereitung/$prepId': typeof AppVorbereitungPrepIdRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/personen/': typeof AppPersonenIndexRoute
  '/_app/meetings/live/$meetingId': typeof AppMeetingsLiveMeetingIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/desktop-login'
    | '/login'
    | '/quick-capture'
    | '/agents'
    | '/archiv'
    | '/bereiche'
    | '/chat'
    | '/einstellungen'
    | '/entscheidungen'
    | '/inbox'
    | '/para'
    | '/projekte'
    | '/ressourcen'
    | '/suche'
    | '/tasks'
    | '/zusagen'
    | '/oauth/consent'
    | '/oauth/login'
    | '/c/$containerId'
    | '/meetings/$meetingId'
    | '/n/$noteId'
    | '/personen/$personId'
    | '/vorbereitung/$prepId'
    | '/meetings/'
    | '/personen/'
    | '/meetings/live/$meetingId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/desktop-login'
    | '/login'
    | '/quick-capture'
    | '/agents'
    | '/archiv'
    | '/bereiche'
    | '/chat'
    | '/einstellungen'
    | '/entscheidungen'
    | '/inbox'
    | '/para'
    | '/projekte'
    | '/ressourcen'
    | '/suche'
    | '/tasks'
    | '/zusagen'
    | '/oauth/consent'
    | '/oauth/login'
    | '/'
    | '/c/$containerId'
    | '/meetings/$meetingId'
    | '/n/$noteId'
    | '/personen/$personId'
    | '/vorbereitung/$prepId'
    | '/meetings'
    | '/personen'
    | '/meetings/live/$meetingId'
  id:
    | '__root__'
    | '/_app'
    | '/desktop-login'
    | '/login'
    | '/quick-capture'
    | '/_app/agents'
    | '/_app/archiv'
    | '/_app/bereiche'
    | '/_app/chat'
    | '/_app/einstellungen'
    | '/_app/entscheidungen'
    | '/_app/inbox'
    | '/_app/para'
    | '/_app/projekte'
    | '/_app/ressourcen'
    | '/_app/suche'
    | '/_app/tasks'
    | '/_app/zusagen'
    | '/oauth/consent'
    | '/oauth/login'
    | '/_app/'
    | '/_app/c/$containerId'
    | '/_app/meetings/$meetingId'
    | '/_app/n/$noteId'
    | '/_app/personen/$personId'
    | '/_app/vorbereitung/$prepId'
    | '/_app/meetings/'
    | '/_app/personen/'
    | '/_app/meetings/live/$meetingId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DesktopLoginRoute: typeof DesktopLoginRoute
  LoginRoute: typeof LoginRoute
  QuickCaptureRoute: typeof QuickCaptureRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OauthLoginRoute: typeof OauthLoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop-login': {
      id: '/desktop-login'
      path: '/desktop-login'
      fullPath: '/desktop-login'
      preLoaderRoute: typeof DesktopLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quick-capture': {
      id: '/quick-capture'
      path: '/quick-capture'
      fullPath: '/quick-capture'
      preLoaderRoute: typeof QuickCaptureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents': {
      id: '/_app/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AppAgentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/archiv': {
      id: '/_app/archiv'
      path: '/archiv'
      fullPath: '/archiv'
      preLoaderRoute: typeof AppArchivRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bereiche': {
      id: '/_app/bereiche'
      path: '/bereiche'
      fullPath: '/bereiche'
      preLoaderRoute: typeof AppBereicheRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/einstellungen': {
      id: '/_app/einstellungen'
      path: '/einstellungen'
      fullPath: '/einstellungen'
      preLoaderRoute: typeof AppEinstellungenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entscheidungen': {
      id: '/_app/entscheidungen'
      path: '/entscheidungen'
      fullPath: '/entscheidungen'
      preLoaderRoute: typeof AppEntscheidungenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/para': {
      id: '/_app/para'
      path: '/para'
      fullPath: '/para'
      preLoaderRoute: typeof AppParaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projekte': {
      id: '/_app/projekte'
      path: '/projekte'
      fullPath: '/projekte'
      preLoaderRoute: typeof AppProjekteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ressourcen': {
      id: '/_app/ressourcen'
      path: '/ressourcen'
      fullPath: '/ressourcen'
      preLoaderRoute: typeof AppRessourcenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suche': {
      id: '/_app/suche'
      path: '/suche'
      fullPath: '/suche'
      preLoaderRoute: typeof AppSucheRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/zusagen': {
      id: '/_app/zusagen'
      path: '/zusagen'
      fullPath: '/zusagen'
      preLoaderRoute: typeof AppZusagenRouteImport
      parentRoute: typeof AppRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/login': {
      id: '/oauth/login'
      path: '/oauth/login'
      fullPath: '/oauth/login'
      preLoaderRoute: typeof OauthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/c/$containerId': {
      id: '/_app/c/$containerId'
      path: '/c/$containerId'
      fullPath: '/c/$containerId'
      preLoaderRoute: typeof AppCContainerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$meetingId': {
      id: '/_app/meetings/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AppMeetingsMeetingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/n/$noteId': {
      id: '/_app/n/$noteId'
      path: '/n/$noteId'
      fullPath: '/n/$noteId'
      preLoaderRoute: typeof AppNNoteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/personen/': {
      id: '/_app/personen/'
      path: '/personen'
      fullPath: '/personen/'
      preLoaderRoute: typeof AppPersonenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/personen/$personId': {
      id: '/_app/personen/$personId'
      path: '/personen/$personId'
      fullPath: '/personen/$personId'
      preLoaderRoute: typeof AppPersonenPersonIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vorbereitung/$prepId': {
      id: '/_app/vorbereitung/$prepId'
      path: '/vorbereitung/$prepId'
      fullPath: '/vorbereitung/$prepId'
      preLoaderRoute: typeof AppVorbereitungPrepIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/live/$meetingId': {
      id: '/_app/meetings/live/$meetingId'
      path: '/meetings/live/$meetingId'
      fullPath: '/meetings/live/$meetingId'
      preLoaderRoute: typeof AppMeetingsLiveMeetingIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAgentsRoute: typeof AppAgentsRoute
  AppArchivRoute: typeof AppArchivRoute
  AppBereicheRoute: typeof AppBereicheRoute
  AppChatRoute: typeof AppChatRoute
  AppEinstellungenRoute: typeof AppEinstellungenRoute
  AppEntscheidungenRoute: typeof AppEntscheidungenRoute
  AppInboxRoute: typeof AppInboxRoute
  AppParaRoute: typeof AppParaRoute
  AppProjekteRoute: typeof AppProjekteRoute
  AppRessourcenRoute: typeof AppRessourcenRoute
  AppSucheRoute: typeof AppSucheRoute
  AppTasksRoute: typeof AppTasksRoute
  AppZusagenRoute: typeof AppZusagenRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCContainerIdRoute: typeof AppCContainerIdRoute
  AppMeetingsMeetingIdRoute: typeof AppMeetingsMeetingIdRoute
  AppNNoteIdRoute: typeof AppNNoteIdRoute
  AppPersonenPersonIdRoute: typeof AppPersonenPersonIdRoute
  AppVorbereitungPrepIdRoute: typeof AppVorbereitungPrepIdRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppPersonenIndexRoute: typeof AppPersonenIndexRoute
  AppMeetingsLiveMeetingIdRoute: typeof AppMeetingsLiveMeetingIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgentsRoute: AppAgentsRoute,
  AppArchivRoute: AppArchivRoute,
  AppBereicheRoute: AppBereicheRoute,
  AppChatRoute: AppChatRoute,
  AppEinstellungenRoute: AppEinstellungenRoute,
  AppEntscheidungenRoute: AppEntscheidungenRoute,
  AppInboxRoute: AppInboxRoute,
  AppParaRoute: AppParaRoute,
  AppProjekteRoute: AppProjekteRoute,
  AppRessourcenRoute: AppRessourcenRoute,
  AppSucheRoute: AppSucheRoute,
  AppTasksRoute: AppTasksRoute,
  AppZusagenRoute: AppZusagenRoute,
  AppIndexRoute: AppIndexRoute,
  AppCContainerIdRoute: AppCContainerIdRoute,
  AppMeetingsMeetingIdRoute: AppMeetingsMeetingIdRoute,
  AppNNoteIdRoute: AppNNoteIdRoute,
  AppPersonenPersonIdRoute: AppPersonenPersonIdRoute,
  AppVorbereitungPrepIdRoute: AppVorbereitungPrepIdRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppPersonenIndexRoute: AppPersonenIndexRoute,
  AppMeetingsLiveMeetingIdRoute: AppMeetingsLiveMeetingIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DesktopLoginRoute: DesktopLoginRoute,
  LoginRoute: LoginRoute,
  QuickCaptureRoute: QuickCaptureRoute,
  OauthConsentRoute: OauthConsentRoute,
  OauthLoginRoute: OauthLoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
